import { useState } from 'react';
import { Box, SxProps, type Theme } from '@mui/material';
import { AmplitudeEvent, trackAmplitudeEvent, SeoFeatureInteracted } from '@/lib/analyticsHelper';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider_provider as Provider } from '@/__generated__/seoSegmentationListingPage';
import { ReadMore } from '@/components/common/ReadMore';
import { useResponsive } from '@/components/hooks/useResponsive';

interface SMBExperienceSummaryProps {
  experienceSummary: NonNullable<Provider['description']>;
  sx?: SxProps<Theme>;
  providerID?: string;
}

export const SMBExperienceSummary = ({
  sx,
  experienceSummary,
  providerID,
}: SMBExperienceSummaryProps) => {
  const { isSmallViewport } = useResponsive();

  const [isExpanded, setIsExpanded] = useState(false);

  const amplitudeTrackingForShowMoreBio = () => {
    const amplitudeData: SeoFeatureInteracted = {
      feature_name: 'Show More Bio',
      provider_id: providerID,
    };

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, amplitudeData);
  };

  const handleShowMoreBio = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = e.target as HTMLAnchorElement;
    if (target.tagName.toLowerCase() === 'button') {
      setIsExpanded(!isExpanded);
      if (!isExpanded) {
        amplitudeTrackingForShowMoreBio();
      }
    }
  };

  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <ReadMore
        color="textPrimary"
        component="div"
        variant="body2"
        charLimit={isSmallViewport ? 210 : 330}
        value={experienceSummary}
        showMoreLabel={isExpanded ? 'less' : 'read more'}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleShowMoreBio(e)}
      />
    </Box>
  );
};
